exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-medical-course[data-v-9282bf9c]{cursor:default!important}.vc-medical-course[data-v-9282bf9c]:hover{border-color:#98a6ad!important;background:#98a6ad!important}.vc-medical-course[data-v-9282bf9c]:focus{box-shadow:none!important}", ""]);

// exports
